import React from "react";


import p1 from "../assets/img/update_2/products/p1.png"
import p2 from "../assets/img/update_2/products/p2.png"
import p3 from "../assets/img/update_2/products/p3.png"

import { Link } from "react-router-dom";

const data = [
  {
    icon: "fa-gift",
    title: "French Fries",
    img: p1,
    bg: "rgb(15, 17, 56)",
    link:'/frenchfries'
  },
  {
    icon: "fa-gift",
    title: "Value Added Products",
    img: p2,
    bg: "rgb(15, 17, 56)",
    link:'/ourspecialty'
  },
  {
    icon: "fa-gift",
    title: "Potato Flakes ",
    img: p3,
    bg: "rgb(15, 17, 56)",
    link:'/potatoflakesandmashed'
  }    
];

const HoverBoxGrid = ({page}) => {
  return (
<div
  className={`container-fluid d-flex flex-wrap justify-content-center align-items-center ${
    page === "product" ? "" : "box-container"
  }`}
>        <h1 className="why-feature_title titlename helvetica mt-5"
            style={{
              color: page === "product" ? "#0f1138" : "#ffffff",
              fontFamily: "helvetica",
            }} 
          >
            PREMIUM PRODUCTS, TRUSTED QUALITY
          </h1>
    {/* </div> */}
        <div className="container-fluid d-flex flex-wrap justify-content-center align-items-center mb-5">
            
        {data.map((item, index) => (
            <div className="col-12 col-lg-4 col-xl-3 p-2" key={index}>
                <img src={item.img} alt="box" className="img-fluid w-100 h-100 object-cover" />
                <div className="position-relative hover-col">
                    <span className="overlay-box d-flex flex-column justify-content-center align-items-center text-white" style={{ backgroundColor: item.bg }}>
                    {/* <i className={`fa ${item.icon} mb-2`} aria-hidden="true"></i> */}
                    <h2 className="h5 boxtitle" >{item.title}</h2>
                    {/* <a href={item.link} className="th-btn rounded-2 d-flex align-items-center" style={{background: '#f0b323'}}>Read More</a> */}
                    <Link to={item.link} className="th-btn rounded-2 d-flex align-items-center" style={{background: '#f0b323'}}>Read More</Link>                                  
                    </span>
                </div>
            </div>
        ))}
        <style>{`
            .box-container {
            // min-height: 70vh;
            background: rgb(240, 179, 35);
            }

            .hover-col {
            //   height: 300px;
            height: 150px;
            overflow: hidden;
            }

            .overlay-box {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            text-align: center;
            z-index: 2;
            transition: 0.6s;
            }

            .overlay-box i {
            font-size: 2.5rem;
            }

            .hover-col:hover {
            // transform: scale(1.05);
            z-index: 5;
            }

            .hover-col:hover .btn {
            transform: scale(1);
            }

            .btn {
            transition: transform 0.5s ease;
            transform: scale(1);
            background: rgb(240, 179, 35);
            color: #000000

            }
            .btn:hover{
            
            background: #111111;
            color: #ffffff

            }

            .hover-col img {
            object-fit: cover;
            height: 100%;
            width: 100%;
            position: relative;
            z-index: 1;
            }

            @media (max-width: 768px) {
            .hover-col {
                height: 200px;
            }
            }

            @media (max-width: 576px) {
            .hover-col {
                height: 180px;
            }
            }
            .boxtitle{
            color:#ffffff;
            }
        `}</style>
        </div>
    </div>

  );
};

export default HoverBoxGrid;
